var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3",attrs:{"id":"admin-marketplace"}},[_c('slide-x-left-transition',{attrs:{"duration":{ enter: 400, leave: 0 }}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }